import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { currentLocationModulesSelector } from 'state/ducks/auth'

const BoloModuleConditional = ({ children, fallbackComponent }) => {
  const hasPermissions = (useSelector(currentLocationModulesSelector) || {}).canViewBolo

  if (hasPermissions) return <>{children}</>

  if (fallbackComponent) return fallbackComponent

  return null
}

BoloModuleConditional.propTypes = {
  children: PropTypes.element.isRequired,
  fallbackComponent: PropTypes.element,
}

BoloModuleConditional.defaultProps = {
  fallbackComponent: undefined,
}

export default BoloModuleConditional
